<template>
  <md-drawer
    class="md-right on-at-start-drawer"
    :md-fixed="true"
    :md-active.sync="state.onAtStartDrawerOpen"
    data-testid="on-at-start-container"
  >
    <div v-if="state.onAtStartDrawerOpen" class="left-navigation" data-testid="on-at-start-navigation-bar">
      <md-button class="md-icon-button" aria-label="Close" data-testid="close-on-at-start-button" @click="closeOnAtStartDrawer()">
        <md-icon>close</md-icon>
      </md-button>
      <md-divider />
      <md-button
        class="md-icon-button"
        :class="{ active: state.activeTab === 'IV' }"
        aria-label="IV On at Start"
        data-testid="iv-on-at-start-button"
        @click="switchTab('IV')"
      >
        <md-icon :md-src="require('@/assets/icons/iv.svg')" />
      </md-button>
      <md-button
        class="md-icon-button"
        :class="{ active: state.activeTab === 'MEDICATION' }"
        aria-label="Medications and Fluids On at Start"
        data-testid="medications-on-at-start-button"
        @click="switchTab('MEDICATION')"
      >
        <md-icon :md-src="require('@/assets/icons/medications.svg')" />
      </md-button>
    </div>
    <md-dialog-content v-if="state.onAtStartDrawerOpen" class="drawer-content">
      <section-title color="#62cd63" data-testid="on-at-start-title">
        On at Start: {{ subtitle[state.activeTab] }}
      </section-title>
      <div class="on-at-start-panel-container">
        <IVOnAtStartPanel
          v-show="state.activeTab === 'IV'"
          :case-conf="caseConf"
          :readonly="readonly"
          :navigation="state.navigation"
          @update="updateInitialIvs"
        />
        <medications-on-at-start-panel
          v-show="state.activeTab === 'MEDICATION'"
          :case-conf="caseConf"
          :readonly="readonly"
          :navigation="state.navigation"
          @update="updateInitialMedications"
        />
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-raised" @click="closeOnAtStartDrawer()">
        DONE
      </md-button>
    </md-dialog-actions>
  </md-drawer>
</template>

<script>
import SectionTitle from '../../common/SectionTitle';
import IVOnAtStartPanel from '../CaseIVs/IVOnAtStart/IVOnAtStartPanel';
import MedicationsOnAtStartPanel from '../CaseMedications/MedicationsOnAtStart/MedicationsOnAtStartPanelContainer';

export default {
  name: 'on-at-start-drawer',
  components: {
    SectionTitle,
    IVOnAtStartPanel,
    MedicationsOnAtStartPanel,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        onAtStartDrawerOpen: false,
        activeTab: 'IV',
        navigation: null,
      },
      subtitle: {
        'IV': 'IV',
        'MEDICATION': 'Medications/Fluids'
      },
    };
  },
  created() {
    this.$eventHub.$on('UI::OPEN_ON_AT_START_PANEL', navigation => {
      this.state.navigation = navigation;
      this.state.onAtStartDrawerOpen = true;
      if (navigation.category === 'ivs') {
        this.state.activeTab = 'IV';
      } else {
        this.state.activeTab = 'MEDICATION';
      }
    });
  },
  methods: {
    closeOnAtStartDrawer() {
      this.state.onAtStartDrawerOpen = false;
    },
    switchTab(activeTab) {
      this.state.activeTab = activeTab;
    },
    updateInitialIvs(initialIvs) {
      this.$emit('updateInitialIvs', initialIvs);
    },
    updateInitialMedications(initialMedications) {
      this.$emit('updateInitialMedications', initialMedications);
    },
  },
};
</script>

<style scoped>
.md-drawer {
  overflow: visible;
  z-index: 1003; /* higher than case logic controls (1002) */
}

.on-at-start-drawer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 1200px;
}

.left-navigation {
  width: 56px;
  height: 100%;
  position: absolute;
  left: -56px;
  z-index: 9999999;
  background-color: #62cd63;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.left-navigation .md-icon-button >>> .md-icon {
  color: #dddddd;
}

.left-navigation .md-icon-button.active >>> .md-icon {
  color: #ffffff;
}

.drawer-content {
  padding: 35px;
}

.md-icon-button >>> svg {
  fill: #dddddd !important;
}
.md-icon-button.active >>> svg {
  fill: white !important;
}

.md-button+.md-button {
    margin-left: 6px;
}
</style>
